export const TOP_SAFE_SPACE_IN_PIXELS = 46;
